<template>
  <div class="content" test-id="identikitForm">
    <div class="flex w-full">
      <div class="w-6">
        <div class="header-form" test-id="identikitHeaderForm">
        <div>
          <Button
            :disabled="this.numberQuestion === 1"
            icon="pi pi-arrow-left"
            class="p-button-rounded p-button-outlined p-button-secondary mt-1"
            v-tooltip.bottom="'Volver a pregunta anterior'"
            @click="backQuestion()"
            test-id="identikitBackButton"
          />
        </div>
        <div class="flex">
          <p test-id="identikitQuestion">Pregunta {{this.numberQuestion}}/13:</p>
          <p class="header-question" test-id="identikitSpecificQuestion"><b>{{this.questions[this.numberQuestion - 1]}}</b></p>
        </div>
        <div test-id="identikitDivNextButton">
          <Button
            :disabled="this.numberQuestion === 13"
            icon="pi pi-arrow-right"
            class="p-button-rounded p-button-outlined p-button-secondary mt-1"
            v-tooltip.bottom="'Siguiente pregunta'"
            @click="nextQuestion()"
            test-id="identikitNextButton"
          />
        </div>

        </div>

        <!-- Descomentar para agregar texto sobre respuestas a identikit obligatorias -->
        <!-- <div class="flex justify-content-center">
           <p class="text-red-500"> Debe responder al menos 6 preguntas de las 13 disponibles </p>
        </div> -->

        <div v-for="item in dropdownAccordionConfig">
          <div  v-for="(question, index) in item.questionDropdownData">
            <DropdownAccordion
              :key="index" 
              :id="'DropdownAccordion' + index"
              :ref="'DropdownAccordion' + index"
              :numberQuestion="numberQuestion"
              :questionNumber="item.questionNumber"
              :title="question.title"
              :dropdowns="question.dropdowns"
              @updateDropdownData="(field, value) => updateDataToStore(field, value)"
              @closeAllAccordions="value => closeAllAccordions(value)"
            />
          </div>
        </div>
        
        <div v-for="item in inputsTextConfig">
          <InputTextIdentikit 
            v-if="item.questionNumber === numberQuestion"
            :title="item.inputData.title"
            :inputName="item.inputData.inputName"
            @updateInput="(field, value) => updateDataToStore(field, value)"
          />
        </div>

        <div class="grid mt-4">
          <div class="flex flex-column col-10 ml-1" test-id="identikitSpecificDIVDescriptionTextArea">
            <Card 
              test-id="identikitSpecificDescription"
              class='w-23rem h-3rem mb-5 bg-gray-100 text-gray-800 shadow-md border border-gray-300 backdrop-blur-sm' 
            >
              <template #content>
                <div class="flex justify-content-between">
                  <p class="-mt-3 -ml-1 font-semibold">{{numberQuestion === 11 || numberQuestion === 12 ? 'Descripción específica' : 'Personalizar respuesta'}}</p>
                </div>
              </template>
            </Card>
            <Textarea 
              v-model="textAreaContent" 
              @input="addAnswer()" 
              @keypress="addAnswer()" 
              :placeholder="numberQuestion === 11 || numberQuestion === 12 ? 'Descripción específica' : 'Personalizar respuesta'"  
              rows="5" 
              cols="10" 
              class="-mt-4 mr-4 w-23rem" 
              test-id="identikitSpecificDescriptionTextArea" 
              ref="textAreaContentHTML"
            />
          </div>
        </div>
        
      </div>
      <div class="w-6 pl-4">
        <div class="flex flex-column mt-1 ml-2">
          <Card class='h-3rem bg-gray-100 text-gray-800 shadow-md border border-gray-300 backdrop-blur-sm' test-id="identikitDescriptionsList">
            <template #content>
              <p class="-mt-3 font-semibold text-lg -ml-1" >Descripción definitiva</p>
            </template>
          </Card>
          <Listbox v-model="selectAnswer" :options="listAnswers" dataKey="answer" optionValue="answer" optionLabel="answer" class="mt-2" style="min-height: 35px" test-id="identikitDescriptionsListbox">
            <template #option="slotProps">
              <div class="flex justify-content-between" >
                <span class="mt-2" :test-id="'identikitDescriptionsListboxRespuesta' + parseInt(slotProps.index + 1) ">{{slotProps.option.answer}}</span>
                <div class="flex justify-content-center align-items-center flex-nowrap" :test-id="'identikitDescriptionsListboxDIVButtons' + parseInt(slotProps.index + 1) ">
                  <Button
                    v-for="button in buttonsAnswer"
                    :key="button.id"
                    :icon="button.icon"
                    class="p-button-lg p-button-rounded p-button-outlined px-2 py-2 m-1"
                    :class="button.aditionalClasses"
                    :style="{color: button.color}"
                    v-tooltip.left="button.tooltip"
                    :disabled="button.disabled(slotProps)" 
                    @click="button.action($event, slotProps)"
                  />
                </div>
              </div>
            </template>
          </Listbox>
          <ConfirmPopup></ConfirmPopup>
        </div>
      </div>
      
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'

import Listbox from 'primevue/listbox';
import ConfirmPopup from 'primevue/confirmpopup/ConfirmPopup';

import DropdownAccordion from '../IdentikitComponents/DropdownAccordion.vue';
import InputTextIdentikit from '../IdentikitComponents/InputTextIdentikit.vue';

import IdentikitComponentsConfig from '../IdentikitComponents/mixins/identikitComponentsConfig';
import IdentikitOptionsData from '../IdentikitComponents/mixins/identikitOptionsData';
import IdentikitProcessingAnswersFunctions from '../IdentikitComponents/mixins/identikitProcessingAnswersFunctions';

export default {
  props: {
    minimal:  String,
    formType: String,
    arrId: String
  },
  name: 'FormNewIdentikit',
  mixins: [
    IdentikitComponentsConfig,
    IdentikitOptionsData,
    IdentikitProcessingAnswersFunctions
  ],
  components: {
    Listbox,
    ConfirmPopup,
    DropdownAccordion,
    InputTextIdentikit
  },
  data() { 
    return {
      errores: {
        identikit: 'El identikit debe tener al menos 6 preguntas respondidas'
      }, 
      numberQuestion: 1,
      questions:  [
        "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
        "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
        "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
        "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
        "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
        "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
        "¿PUEDE DETALLAR EL ACENTO DEL INDIVIDUO?",
        "¿VIO SI EL INDIVIDUO TENÍA ALGÚN ACCESORIO PERSONAL? (PIERCING, LENTES..) ",
        "¿CÓMO SE MOVILIZABA EL INDIVIDUO?",
        "¿QUÉ ELEMENTO/S UTILIZÓ EL/LA CONTRAVENTOR/A?",
        "¿ESCUCHÓ O CONOCE EL APODO DEL INDIVIDUO?",
        "¿HAY ALGUNA OTRA DESCRIPCIÓN QUE QUIERA AGREGAR?",
        "¿HUBIERON CÓMPLICES EN EL HECHO?",
      ],
      listAnswers: [],
      selectAnswer: null,
      originalAnswersWithoutEdit: [],
      questionsThatWereGivenNextForFirstTime: []
    }
  },
  watch: {
    arrId: function () {
      this.updateListAnwserWithStore()
    },
  },
  // Esta función se asegura que la primera vez en entrar al componente, se validen las respuestas del identikit
  // created(){
  //   this.verifyAmountRequiredOfAnswers();
  // },
  computed: {
    ...mapGetters('sumario/acusados', [
      'getAcusadoByArrId'
    ]),
  },
  methods: {                                     
    setData(data){
      for (let i of this.fields) {
        this[i] = data[i] || null
      }
    },
    $_TemplateForm_update( field, value ){
      this.$emit("updateValue", field, value)
    },
    handleUpdateDescriptionOffender(){
      this.$emit("updateValue", "listAnswers", this.listAnswers)
    },
    nextQuestion(){
      this.saveForFirstTime();
      this.addAnswer()
      this.$store.dispatch("sumario/textResetEditsCounter","Contravener")
      this.numberQuestion = parseInt(this.numberQuestion) + 1
      this.$emit("updateValue", "numberQuestion", this.numberQuestion)
      // this.textAreaContent = ""
      this.putOnTextAreaTheCurrentAnswer();
    },
    backQuestion(){
      this.saveForFirstTime();
      this.addAnswer();
      this.numberQuestion = parseInt(this.numberQuestion) - 1;
      this.$emit("updateValue", "numberQuestion", this.numberQuestion);
      // this.textAreaContent = "";
      this.putOnTextAreaTheCurrentAnswer();
    },
    saveForFirstTime(){
      const theQuestionAlreadyExists = this.originalAnswersWithoutEdit.find(question => question?.questionNumber === this.numberQuestion);
      const originalAnswer = this.listAnswers.find(answer => answer.questionNumber === this.numberQuestion);
      if(theQuestionAlreadyExists === undefined && originalAnswer !== undefined){
        this.originalAnswersWithoutEdit.push(originalAnswer);
      } 
    },
    putOnTextAreaTheCurrentAnswer(){
      const currentAnswer = this.listAnswers.find(answer => answer.questionNumber === this.numberQuestion);
      if(currentAnswer?.answerToTextAreaContent === undefined){ 
        this.textAreaContent = ""
      } else  {
        this.textAreaContent = currentAnswer?.answerToTextAreaContent;
      }
    },
    updateDataToStore(field, value){
      this[field] = value;
    },
    closeAllAccordions(exception){
      for (let refProp in this.$refs) {
        if(refProp.includes('DropdownAccordion') && refProp !== exception){
          for (let i = 0; i < this.$refs[refProp].length; i++) {
            this.$refs[refProp][i].show = false;
          }
        } 
      }
    },
  }
}
</script>

<style scoped>

  .content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    
  }
  div.card {
    width: 100%;
  }
  .map {
    display: block;
    margin-top: 10px;
    height: 60vh;
    width: 50vw;
  }
  .title {
    padding-top: 5px;
    padding-bottom: 0px;
    font-size: 1rem;
  }
  .title-toolbar {
    display: flex;
    justify-content: space-between;
  }
  .search > input {
    margin-right: 10px;
  }
  .forms > div, .labeled, .inputType {
    display: flex;
    flex-wrap: wrap;
  }
  .inputType label {
    display: none;
  }
  .forms > div, .labeled {
    flex-direction: column;
  }
  .forms > div.actions {
    flex-direction: row-reverse;
    padding-right: 20px;
  }
  .forms > div .input {
    min-width: 20vw;
    margin-top: 10px;
    margin-bottom: 20px;
    margin-right: 20px;
  }
  div.flex-inline {
    display: flex;
    flex-wrap: wrap;
  }
  .minus10 {
    margin-top: -5px;
  }
  .header-form{
    display: flex;
    justify-content: space-between;
    width: 100%;
    border-bottom: 1px solid #969ca3;
    color: #969ca3;
    padding: 0 4px 0 4px
  }
  .header-question{
    margin-left: 10px;
    color: black;
  }
  .description-content{
    margin-top: 2rem;
  }
  .input{
    max-width: 13rem
  }
  .description-autocomplete{
    margin-left: 30px;
    max-width: 150px
  }
  .checkbox-container{
    width: 120px;
    margin-left: 8px
  }
  @media(min-width: 1362px)   {
    .add-button {
      height: 40px ;
      width: 150px ;
      margin-top: 36px ;
    }
  }
  @media(max-width: 1362px)   {
    .add-button {
      height: 40px ;
      width: 150px ;
      margin: 15px auto auto 15px;;
    }
  }
  .autocomple-size{
    width: 183px;
    min-width: 183px;
    margin-left: 5px;
    margin-top: -5px
  }
  .autocomple-size-question3{
    width: 220px;
    min-width: 183px;
    margin-left: 5px;
    margin-top: -5px
  }
  .autocomple-size-multiSelect{
    width: 220px;
    min-width: 183px;
    margin-left: 5px;
    margin-top: -5px
  }
  .pseudoTextarea{
    margin-top: 0.6rem;
    width: 97%;
    min-height: 80px;
    max-height: 180px;
    border: 1px solid #d5dadf;
  }
  .pseudoTextarea-content{
    margin: 10px 5px 10px 10px;
  }
  .slider-mt{
    margin-top: -25px
  }
  .inputText-size{
    width: 183px;
    min-width: 183px;
    margin-left: 5px;
    margin-right: 40px;
    margin-top: -5px
  }
  .chevron-color{
    color: #7d858c;
  }
  .dropdown-container {
    display: flex;
    flex-direction: column;
    width: 100%; 
    gap: 10px;
  }
  .dropdown-question {
    width: 100%;
    margin-bottom: 20px;
  }
</style>